const LIST_BEGIN = /\\begin\{(itemize|enumerate)\}/g
const LIST_END = /\\end\{(itemize|enumerate)\}/g
const STRAY_ITEM = /^\s*\\item\[[^\]]*\]\s*/

/**
 * Drops a leading `\item[n]` / `\item[]` token from lines that sit outside any
 * itemize/enumerate block, keeping the text.
 *
 * Paper extraction stores question stems as `\item[3] Find ...` with the
 * answer options in a following itemize. mathpix-markdown-it renders an
 * `\item` outside a list as an empty `<li>`, so the whole stem vanishes. The
 * question number is already shown by the UI, so the label is not kept.
 */
export const unwrapStrayItemStems = (content: string): string => {
  if (!content || !content.includes('\\item[')) return content

  let depth = 0
  return content
    .split('\n')
    .map((line) => {
      const out = depth === 0 ? line.replace(STRAY_ITEM, '') : line
      depth += (line.match(LIST_BEGIN) || []).length
      depth -= (line.match(LIST_END) || []).length
      if (depth < 0) depth = 0
      return out
    })
    .join('\n')
}
